import React from 'react';
import { Box, Text, Title } from '@nimbus-ds/components';
import AppLayout from 'App/components/AppLayout';
import { HelpLink } from 'commons/components';
import { useIsMobile } from 'commons/hooks';
import { useTranslationWithPrefix } from 'commons/utils';

function InvalidIndustry(): JSX.Element {
  const { t } = useTranslationWithPrefix('emptyState.invalidIndustry');
  const isMobile = useIsMobile();

  return (
    <AppLayout title={t('title')}>
      <Box
        display="flex"
        flexDirection={isMobile ? 'column' : 'row'}
        gap="8"
        padding="4"
        alignItems="center"
        height={isMobile ? '70vh' : '75vh'}
        data-testid="invalid-industry"
      >
        <img
          src="/assets/img/invalid-industry.png"
          alt="Invalid Industry Empty State"
          style={{ maxWidth: isMobile ? '200px' : '320px' }}
        />
        <Box display="flex" flexDirection="column" gap="4">
          <Title as="h3" textAlign={isMobile ? 'center' : 'left'}>
            {t('subtitle')}
          </Title>
          <Text textAlign={isMobile ? 'center' : 'left'}>
            {t('description')}
          </Text>
        </Box>
      </Box>
      <HelpLink
        href={t('helpLink.href')}
        text={t('helpLink.text')}
        appearance="primary"
        textDecoration="none"
      />
    </AppLayout>
  );
}

export default InvalidIndustry;
